import { nanoid } from 'nanoid';
import React, { Component } from 'react';
import { GlobalContext } from '../../interfaces/GlobalContext/GlobalContext';
import { LoginForm, LoginFormFields, LoginStatusCode } from '../../services/LoginProvider/LoginProvider.props';
import FormField from '../FormField/FormField';
import FormFieldInputText from '../FormFieldInputText/FormFieldInputText';
import LoginSectionProps from './LoginSection.props';
import LoginSectionState from './LoginSection.state';

export default class LoginSection extends Component<LoginSectionProps, LoginSectionState> {
    static contextType = GlobalContext;
    context!: React.ContextType<typeof GlobalContext>;
    private formElement: React.RefObject<HTMLFormElement>;
    private isLoggedIn: boolean | undefined;
    private modalElement: React.RefObject<HTMLDivElement>;
    private formId: string;

    constructor(props: LoginSectionProps) {
        super(props);
        this.state = {};

        this.formElement = React.createRef<HTMLFormElement>();
        this.isLoggedIn = this.props.isLoggedIn;
        this.modalElement = React.createRef<HTMLDivElement>();
        this.formId = nanoid();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
    }

    async handleSubmit(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        
    }

    componentDidMount() {
        if (!this.isLoggedIn) {
            try {
                this.modalElement.current?.instance || window.Juris.moduleRegistry.applyModule('Modal', this.modalElement.current);
            } catch (error) {
                console.log(error);
            }
    
            try {
                this.formElement.current?.instance || window.Juris.moduleRegistry.applyModule('Form', this.formElement.current);
            } catch (error) {
                console.log(error);
            }
        }
    }

    async handleLogin(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        const formData = await this.context.utilityProvider.getObjectFromForm(this.formElement.current) as LoginForm;

        this.setState({
            loginStatus: await this.context.loginProvider.login(formData[LoginFormFields.USERNAME], formData[LoginFormFields.PASSWORD])
        }, async () => {
            if (this.state.loginStatus !== LoginStatusCode.LOGINSUCCESSFUL) {
                this.modalElement.current?.instance.show();
            } else {
                const customerData = await this.context.loginProvider.getUserInformation();
                if (customerData && typeof customerData !== 'number') {
                    this.context.localStorageProvider.removeCustomerDataFromLocalStorage();
                    this.props.formElement?.current?.reset();
                    this.context.localStorageProvider.setCustomerDataInLocalStorage(customerData);
                    this.props.loggedInUpdate && this.props.loggedInUpdate(this.context.localStorageProvider.getCustomerDataFromLocalStorage());
                }
            }
        })
    }

    handleLogout(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();
        
        this.props.formElement?.current?.reset();
        this.context.loginProvider.logout();
        this.props.loggedInUpdate && this.props.loggedInUpdate();
    }

    render(): React.ReactNode {

        if (!this.isLoggedIn) {
            return (
                <section className="cs-login-shop content-section in-viewport">
                    <div className="container">
    
                        <div className="login-shop">
                            <div className="login-shop__container">
                                <div className="login-shop__row row">
                                    <div className="login-shop__col col-12 col-lg-10 offset-lg-1">
                                        <div className="login-shop__headline textblock" 
                                            dangerouslySetInnerHTML={{__html:this.context.i18nProvider.get('customerDataPage.loginSection.title')||''}}></div>
                                    </div>
                                    <div className="login-shop__col col-12 col-md-5 col-lg-5 offset-lg-1">
                                        <div className="login-shop__text textblock" 
                                            dangerouslySetInnerHTML={{__html:this.context.i18nProvider.get('customerDataPage.loginSection.text')||''}}></div>
                                    </div>
                                    <div className="login-shop__col col-12 col-md-6 col-lg-5 offset-md-1 offset-lg-0">
                                        <form className="login-shop__form" onSubmit={this.handleLogin} ref={this.formElement} id={this.formId}>
                                            <div className="login-shop__form-content">
                                                <div className="form__row row">
                                                    <FormField errorMessage={this.context.i18nProvider.get("customerDataPage.loginSection." + LoginFormFields.USERNAME + ".errorMessage")}>
                                                        <FormFieldInputText id={LoginFormFields.USERNAME}
                                                            label={this.context.i18nProvider.get("customerDataPage.loginSection." + LoginFormFields.USERNAME + ".label")}
                                                            required={true}
                                                            maxLength={50} />
                                                    </FormField>
                                                </div>
                                                <div className="form__row row">
                                                    <FormField errorMessage={this.context.i18nProvider.get("customerDataPage.loginSection." + LoginFormFields.PASSWORD + ".errorMessage")}>
                                                        <FormFieldInputText id={LoginFormFields.PASSWORD}
                                                            label={this.context.i18nProvider.get("customerDataPage.loginSection." + LoginFormFields.PASSWORD + ".label")}
                                                            required={true}
                                                            validation={'password'}
                                                            maxLength={50} />
                                                    </FormField>
                                                </div>
                                            </div>
                                            <div className="login-shop__button-container">
                                                <a href={this.context.i18nProvider.get('customerDataPage.loginSection.forgottenPw') || '/'} 
                                                    className='login-shop__pw-reset'>{this.context.i18nProvider.get('customerDataPage.loginSection.pwReset')}</a>
                                                <div className="login-shop__submit-btn">
                                                    <button className="cta-button cta-button--button-dark cta-button--uppercase cs-login-shop" 
                                                        type="submit"
                                                        form={this.formElement.current?.id}
                                                        onClick={(e) => this.handleSubmit}>{this.context.i18nProvider.get('customerDataPage.loginSection.loginLabel')}</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="login-shop__modal">
                                <div className="modal" ref={this.modalElement}>
                                    <div className="modal__container container">
                                        <div className="modal__content">
                                            <button className="modal__close-btn" type="button">
                                                <span className="modal__close-btn-icon"></span>
                                            </button>
                                            <div className="modal__body">
                                                <div className="textblock" dangerouslySetInnerHTML={{
                                                    __html: this.state.loginStatus === LoginStatusCode.LOGINFORBIDDENTOBUY
                                                        ? this.context.i18nProvider.get('customerDataPage.loginSection.noOrderPossible') || ''
                                                        : this.context.i18nProvider.get('customerDataPage.loginSection.loginFailed') || ''
                                                }}></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            );
        } else {
            return (
                <div className="login-shop__logout-button-container container">
                    <p className="login-shop__logout-info-text">{this.context.i18nProvider.get('customerDataPage.loginSection.logoutInfoText')}</p>
                    <div className="login-shop__submit-btn">
                        <button className="cta-button cta-button--button-dark cta-button--uppercase cs-login-shop" 
                            type="submit"
                            form={this.formElement.current?.id}
                            onClick={(e) => this.handleLogout(e)}>{this.context.i18nProvider.get('customerDataPage.loginSection.logoutLabel')}</button>
                    </div>
                </div>
            )
        }
    }
}
